import { render, staticRenderFns } from "./DisciplineStatements.vue?vue&type=template&id=438bcd2e&scoped=true&"
import script from "./DisciplineStatements.vue?vue&type=script&lang=js&"
export * from "./DisciplineStatements.vue?vue&type=script&lang=js&"
import style0 from "./DisciplineStatements.vue?vue&type=style&index=0&id=438bcd2e&lang=scss&scoped=true&"
import style1 from "./DisciplineStatements.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "438bcd2e",
  null
  
)

export default component.exports